import { render, staticRenderFns } from "./VideoWatchHistory.vue?vue&type=template&id=48671577"
import script from "./VideoWatchHistory.vue?vue&type=script&lang=js"
export * from "./VideoWatchHistory.vue?vue&type=script&lang=js"
import style0 from "./VideoWatchHistory.vue?vue&type=style&index=0&id=48671577&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports